export default "__VITE_ASSET__64420605__"